/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Toast_CreatedInputs */

const en_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const de_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const fr_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const es_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const it_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const nl_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const pl_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const fi_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const da_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

const sv_story_bank_toast_created = /** @type {(inputs: Story_Bank_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story created`)
};

/**
* | output |
* | --- |
* | "Story created" |
*
* @param {Story_Bank_Toast_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_toast_created = /** @type {((inputs?: Story_Bank_Toast_CreatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Toast_CreatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_toast_created(inputs)
	if (locale === "fr") return fr_story_bank_toast_created(inputs)
	if (locale === "es") return es_story_bank_toast_created(inputs)
	if (locale === "it") return it_story_bank_toast_created(inputs)
	if (locale === "nl") return nl_story_bank_toast_created(inputs)
	if (locale === "pl") return pl_story_bank_toast_created(inputs)
	if (locale === "fi") return fi_story_bank_toast_created(inputs)
	if (locale === "da") return da_story_bank_toast_created(inputs)
	if (locale === "sv") return sv_story_bank_toast_created(inputs)
	return en_story_bank_toast_created(inputs)
});